import { Dialog } from '@angular/cdk/dialog';
import { Component, Input, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { PlatformNavigationMenuItem } from 'src/app/components/main-navigation/types';
import { NavigationBlockerDialogComponent } from './navigation-blocker-dialog/navigation-blocker-dialog.component';

@Component({
    selector: 'navigation-blocker-layout',
    templateUrl: './navigation-blocker-layout.component.html',
    styleUrls: ['./navigation-blocker-layout.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavigationBlockerLayoutComponent implements OnInit {
    public readonly menuList: PlatformNavigationMenuItem[] = [
        { label: 'NEWS_PAGE.TITLE', e2eHook: 'main-navigation-news-button', route: { target: '/platform/news' } },
        {
            label: 'BRAND_OVERVIEW_PAGE.TITLE',
            e2eHook: 'main-navigation-brand-overview-button',
            route: { target: '/platform/brands' }
        },
        {
            label: 'CONTENT_PAGE.TITLE',
            e2eHook: 'main-navigation-content-button',
            route: { target: '/platform/content' }
        },
        {
            label: 'ORDER_PLATFORM_PAGE.TITLE',
            e2eHook: 'main-navigation-reorder-button',
            route: { target: '/platform/reorder' }
        },
        {
            label: 'PREORDER_PLATFORM_PAGE.TITLE',
            e2eHook: 'main-navigation-preorder-button',
            route: { target: '/platform/preorder' }
        }
    ];

    @Input() template: TemplateRef<any>;

    mobileView = window.screen.width < 1280;

    constructor(private dialog: Dialog) {}

    ngOnInit(): void {
        this.dialog.open<string>(NavigationBlockerDialogComponent, {
            disableClose: true,
            panelClass: 'navigation-blocker-dialog-panel-class',
            data: { template: this.template },
            closeOnNavigation: true
        });
    }
}
